
// import ApplicationTitle from '../../components/ApplicationTitle';
import TextInput from '../../components/input_fields/TextInput';
import TwoInputs from '../../components/input_fields/TwoInputs'
import FormTitle from '../../components/form_titles/FormTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
import ProgressBar from '../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";

export default function Step6({ nextStep, handleFormData, prevStep, values, validation, color }) {

  const [finInstError, setFinInstError] = useState(false)
  const [finPhoneError, setFinPhoneError] = useState(false)
  const [checkingNumError, setCheckingNumError] = useState(false)
  const [bankABAError, setBankABAError] = useState(false)

  const submitFormData = (e) => {
    e.preventDefault()

    if (validation) {
      // Financial Institute Street Error
      if (validator.isEmpty(values.finInst)) {
        setFinInstError(true)
        return
      } setFinInstError(false)

      // Financial Phone Error
      if (!validator.isMobilePhone(values.finPhone)) {
        setFinPhoneError(true)
        return
      } setFinPhoneError(false)

      // Financial Checking Error
      if (validator.isEmpty(values.checkingNum) || values.checkingNum.length < 6) {
        setCheckingNumError(true)
        return
      } setCheckingNumError(false)

      // Financial ABA Error
      if (!validator.isNumeric(values.bankABA) || values.bankABA.length !== 9) {
        setBankABAError(true)
        return
      } setBankABAError(false)
    }
    nextStep()
  }

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        {/* <ApplicationTitle 
            mainTitle = "Bipsypay Merchant Application"
            subTitle = "Complete the form below to begin your Bipsypay merchant application"
        /> */}
        <ProgressBar
          progress="72%"
          color = {color}
        />
        <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <FormTitle
              color = {color}
              mainTitle="Let's talk"
              colorTitle="numbers."
              subText="Indicate where you want your funded credit card transaction to be deposited."
              modalTitle="Why do you need this..."
              modalDesc="You want to get paid don’t you? All transactions will fund to this account but we need to verify the bank is legit."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TwoInputs
                color = {color}
                placeholder1="Financial Institution" id1="fin_inst" name1="finInst" type1="text" value1={values.finInst}
                error1={finInstError} message1={"Please provide a financial institution."}
                handleInputChange1={handleFormData}
                placeholder2="Phone Number" id2="phone" name2="finPhone" type2="text" value2={values.finPhone}
                error2={finPhoneError} message2={"Please enter a valid phone number."}
                handleInputChange2={handleFormData}
              />

              <TextInput
                color = {color} 
                placeholder="Checking Account Number" id="checking_num" name="checkingNum" type="text" value={values.checkingNum}
                error={checkingNumError} message={"Please enter a checking account number that is at least 6 characters long."}
                handleInputChange={handleFormData}
              />

              <TextInput
                color = {color} 
                placeholder="Bank ABA Routing Number" id="aba_num" name="bankABA" type="text" value={values.bankABA}
                error={bankABAError} message={"Please enter a 9 digit routing number."}
                handleInputChange={handleFormData} 
              />

              <DoubleButton color = {color} prevStep={prevStep} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}